import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  paymentOption: null,
  createTransferSuccess: {},
  createTransferFailure: {},
};

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    createTransferSuccess: (state, action) => {
      state.createTransferSuccess = action.payload;
    },
    createTransferFailure: (state, action) => {
      state.createTransferFailure = action.payload;
    },
    selectPaymentOption: (state, action) => {
      console.log("Storing paymentOption:", action.payload);
      state.paymentOption = action.payload;
    },
    resetPaymentOption: (state) => {  
      console.log("Resetting paymentOption to null");
      state.paymentOption = null;
    },
  },
});

export const { selectPaymentOption, resetPaymentOption, createTransferSuccess, createTransferFailure } = paymentSlice.actions;

// export const selectPaymentOptionState = (state) => state.payment.paymentOption;

export default paymentSlice.reducer;
